export { default } from './WalletsCreated';
